import { LIST_PATHNAME_EDIT_CODE } from '@libs/constants'
import { LoadingPage } from '@pages/loading-page'
import { useContext } from '@utils/context'
import { useLocation } from 'react-router-dom'
import FeedBackIcon from './FeedBackIcon'
import PolarisLayout from './PolarisLayout'

type ProtectedRouteProps = {
  children: React.ReactNode
  noFrame?: boolean
}

const ProtectedRoute = ({ children, noFrame }: ProtectedRouteProps) => {
  const { pathname } = useLocation()
  const [rootState] = useContext()
  const subscription = rootState?.ShopReducer?.subscription
  const hasShopData = Boolean(
    subscription && (subscription.shopify_domain || subscription.shop_id),
  )
  const isThemesEdit = LIST_PATHNAME_EDIT_CODE.some(prefix =>
    pathname.startsWith(prefix),
  )
  const showFeedBack = !pathname.includes('modal') && !isThemesEdit

  if (!hasShopData) return <LoadingPage title="Loading data..." />
  return (
    <div>
      <PolarisLayout noFrame={noFrame}>
        {children}
        {showFeedBack ? <FeedBackIcon /> : null}
      </PolarisLayout>
    </div>
  )
}
export default ProtectedRoute
